<div class="modal-header">
  <h5 class="modal-title">Satırları Cihazdan İade Et</h5>
  <button type="button" class="btn-close" (click)="close()" [disabled]="sending"></button>
</div>

<!-- ══ 1) Satır seçimi ══ -->
<div class="modal-body" *ngIf="step === 'confirm'">
  <div class="small text-muted mb-2">
    {{ sale.caseName }}
    <span *ngIf="sale.maskedPan" class="font-monospace ms-1">{{ sale.maskedPan }}</span>
    · Belge {{ sale.amount | number:'1.2-2' }} ₺
    <span *ngIf="sale.refundedAmount"> · İade edilen {{ sale.refundedAmount | number:'1.2-2' }} ₺</span>
  </div>

  <div *ngIf="loading" class="text-center py-3"><div class="spinner-border text-primary"></div></div>

  <ng-container *ngIf="!loading && lines.length">
    <p class="mb-2">İade edilecek satırları seçin. Seçilen satırlar tamamen iade edilir.</p>
    <div class="table-responsive mb-3">
      <table class="table table-sm align-middle mb-0">
        <thead class="table-light">
          <tr><th style="width: 2rem"></th><th>Kalem</th><th class="text-end">Miktar</th><th class="text-end">Tutar</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let l of lines" [class.text-muted]="isRefunded(l)" (click)="toggle(l)"
              [style.cursor]="isRefunded(l) ? 'default' : 'pointer'">
            <td>
              <input class="form-check-input" type="checkbox" [checked]="selectedLineNos.has(l.lineNo)"
                     [disabled]="isRefunded(l) || sending" (click)="$event.stopPropagation(); toggle(l)"
                     [attr.aria-label]="l.name">
            </td>
            <td>
              {{ l.name }}
              <span class="badge bg-light text-muted border ms-1" *ngIf="isRefunded(l)">İade edildi</span>
              <div class="small text-muted" *ngIf="l.specialTaxBaseCode">
                has {{ l.hasAmount | number:'1.2-2' }} · işçilik {{ l.labourAmount | number:'1.2-2' }}
              </div>
            </td>
            <td class="text-end text-nowrap">{{ l.quantity | number:'1.0-3' }} {{ l.unitCode === 'GRM' ? 'gr' : 'ad' }}</td>
            <td class="text-end text-nowrap">{{ l.totalPrice | number:'1.2-2' }} ₺</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th colspan="3" class="text-end">İade tutarı</th>
            <th class="text-end text-nowrap">{{ selectedTotal | number:'1.2-2' }} ₺</th>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="alert alert-warning py-2 small" *ngIf="!openLineCount">Bu satışın bütün satırları iade edilmiş.</div>
    <div class="alert alert-light border py-2 small mb-2" *ngIf="hasCash">
      Belgede nakit ödeme de var: iade önce karta (kart tutarı kadar), artanı nakit olarak döner.
    </div>
    <div class="alert alert-info py-2 small mb-2" *ngIf="isLinked">
      Bu ödeme bir satışa bağlı. İade onaylanınca iade tutarı POS kasasından (nakit kısmı nakit kasasından) çıkar,
      müşteriye borç yazılır ve iade edilen satırların yasal stok çıkışı geri alınır. Komisyon geri yazılmaz.
      Satış kaydı yerinde kalır; ürünü iade aldıysanız satışı ayrıca düzeltin.
    </div>
    <p class="small text-muted mb-0">
      E-faturalı satışta kısmi iade yapılamaz; belgenin tamamı için satışı iptal edin.
    </p>
  </ng-container>

  <div class="alert alert-danger py-2 small mt-3 mb-0" *ngIf="error">{{ error }}</div>
</div>

<!-- ══ 2) Bekleme ══ -->
<div class="modal-body text-center py-4" *ngIf="step === 'waiting' && transaction">
  <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem"
       *ngIf="transaction.status !== Status.Suspended"></div>
  <i class="bx bx-pause-circle text-warning mb-3" style="font-size: 3.5rem" *ngIf="transaction.status === Status.Suspended"></i>
  <div class="fs-4 fw-bold">{{ transaction.amount | number:'1.2-2' }} ₺</div>
  <div class="mb-2">
    <span class="badge bg-{{ statusColor(transaction.status) }}">{{ statusLabel(transaction.status) }}</span>
  </div>
  <p class="mb-1">{{ waitingText }}</p>
  <p class="small text-muted mb-0" *ngIf="transaction.cancelRequestedAt">
    Geri çekme istendi; cihazın teyidi bekleniyor. İade bu arada cihazda tamamlandıysa gerçekleşmiş olur.
  </p>
  <div class="alert alert-warning py-2 small mt-3 mb-0" *ngIf="pollError">
    {{ pollError }}
    <button class="btn btn-sm btn-link p-0 ms-1" (click)="checkNow()">Durumu sorgula</button>
  </div>
</div>

<!-- ══ 3) Sonuç ══ -->
<div class="modal-body text-center py-4" *ngIf="step === 'result' && transaction">
  <ng-container *ngIf="approved; else notApproved">
    <i class="bx bx-check-circle text-success" style="font-size: 3.5rem"></i>
    <h5 class="mt-2">İade yapıldı</h5>
    <p class="text-muted mb-0">
      {{ transaction.amount | number:'1.2-2' }} ₺ iade edildi.
      <ng-container *ngIf="isLinked">
        İade kasadan çıktı, müşteriye borç yazıldı, iade edilen satırların stoğu geri alındı.
      </ng-container>
    </p>
  </ng-container>
  <ng-template #notApproved>
    <i class="bx text-danger" style="font-size: 3.5rem"
       [ngClass]="transaction.status === Status.Cancelled ? 'bx-block' : 'bx-x-circle'"></i>
    <h5 class="mt-2">{{ transaction.status === Status.Cancelled ? 'İade isteği geri çekildi' : 'İade yapılamadı' }}</h5>
    <p class="text-muted mb-0">{{ transaction.errorMessage || statusLabel(transaction.status) }}</p>
  </ng-template>
</div>

<div class="modal-footer">
  <ng-container *ngIf="step === 'confirm'">
    <button class="btn btn-light" (click)="close()" [disabled]="sending">Vazgeç</button>
    <button class="btn btn-danger" (click)="send()" [disabled]="sending || loading || !selectedLineNos.size">
      <span class="spinner-border spinner-border-sm me-1" *ngIf="sending"></span>
      <i class="bx bx-revision me-1" *ngIf="!sending"></i>Cihazdan İade Et
    </button>
  </ng-container>
  <ng-container *ngIf="step === 'waiting'">
    <button class="btn btn-light me-auto" (click)="close()"
            ngbTooltip="İşlem açık kalır; sonucu POS İşlemleri ekranında izlenir." container="body">
      Arka planda bırak
    </button>
    <button class="btn btn-outline-danger" (click)="cancelOnDevice()"
            [disabled]="cancelling || !!transaction?.cancelRequestedAt">
      <span class="spinner-border spinner-border-sm me-1" *ngIf="cancelling"></span>Cihazdan Geri Çek
    </button>
  </ng-container>
  <ng-container *ngIf="step === 'result'">
    <button class="btn btn-primary" (click)="close()">Tamam</button>
  </ng-container>
</div>
